import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import { useState } from 'react';
import { Optional } from '../../Shared';
import type { GroupWithOptions } from './types';

type CollapsibleGroupOptions = {
  readonly groupWithOptions: GroupWithOptions;
};

type CollapsibleGroupProps = {
  readonly onChange: (selectedId: string) => void;
} & CollapsibleGroupOptions;

/**
 * One 'group' of a `GroupSelect` component.
 * It has an expand/collapse button,
 *    which is alongside a heading,
 *    which is above a list of options,
 *    which are rendered as buttons
 * @param onChange Called when an option button is selected
 * @param option the heading and its sub-options
 * @returns the heading and its child options as buttons.
 */
const CollapsibleGroup = ({
  groupWithOptions,
  onChange,
}: CollapsibleGroupProps) => {
  const [collapse, setCollapse] = useState(false);
  return (
    <Row>
      <Col span={24}>
        <Row wrap={false}>
          <Col flex="20px">
            <Button
              onClick={() => setCollapse(!collapse)}
              style={{
                width: '20px',
                height: '20px',
                float: 'left',
                border: 'none',
                padding: 0,
                color: 'black',
              }}
            >
              {collapse ? <PlusOutlined /> : <MinusOutlined />}
            </Button>
          </Col>
          <Col flex="auto">
            <p style={{ fontSize: '14px', fontWeight: 500, margin: 0 }}>
              {groupWithOptions.groupTitle}
            </p>
          </Col>
        </Row>
      </Col>

      <Optional show={!collapse}>
        <Col span={24}>
          {groupWithOptions.options.map((v, i) => (
            <input
              key={i}
              className={'select-option-button'}
              onClick={() => onChange(v.id)}
              value={v.value}
              type="button"
              style={{
                margin: '2px',
                border: '1px solid lightgrey',
              }}
            />
          ))}
        </Col>
      </Optional>
    </Row>
  );
};

export default CollapsibleGroup;
